export enum RoleType {
    SuperAdmin = 'SuperAdmin',
}
